import { ContentApiResponse } from "@shared/types/ContentTypes";
import { apiGet } from "./apiHelper";

export const fetchContent = async (
    url: string,
    signal?: AbortSignal
): Promise<{ data: ContentApiResponse; statusCode: number }> => {
    const relativePath = `/api/content/GetContentByUrl?url=${encodeURIComponent(
        url
    )}&preview=false`;
    return await apiGet<ContentApiResponse>(relativePath, { signal });
};
